 const CustomArrowIcon = () => {
  return (
    <div>
        <svg className="icon transition-all size-4 duration-300 fill-secondary rotate-[270deg]" style={{fill:"#b3bec1"}} viewBox="0 0 32 32"><path d="M20.1912 6.1001L9.79119 16.5001L20.1912 26.9001L23.2088 23.8825L15.8264 16.5001L23.2088 9.1177L20.1912 6.1001Z"></path></svg>
    </div>
  )
}

export default CustomArrowIcon